import React, { useState, useEffect, useRef } from "react";
import './CountDownTimer.css';

import { CountdownCircleTimer } from "react-countdown-circle-timer";




const timerSize = 90;

function CountDownTimer({ duration, questionAnswerTime, isPlaying, setQuestionNum, setIsNextQuestion, setDuration }) {

  // const isMounted = useRef(true);
  let isMounted = true;
  useEffect(()=>{
    return () => {isMounted=false;}
  },[])

  return (
    <div className="question-timer">
      <CountdownCircleTimer
        isPlaying={(isMounted) ? isPlaying : false}
        initialRemainingTime={duration}
        duration={duration}
        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
        colorsTime={[7, 5, 2, 0]}
        size={timerSize}
        onComplete={() => {
          // increment question no.
          setQuestionNum(prev => prev + 1);
          // set duration to questionAnswerTime
          setDuration(questionAnswerTime);
          // set next question back to false after handling the transition
          setIsNextQuestion(false);
          return ()=>{};
        }}
      >
        {({ remainingTime }) => remainingTime}
      </CountdownCircleTimer>

    </div>
  );


}

export default CountDownTimer;